import { createContext } from 'react';
export const HeatingModeContent = createContext({});
const default_control = {
    setSelectedModeId: () => { },
    selected_mode_id: null,
};
export const HeatingModeControl = createContext(default_control);
